import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			closeButton: {
				color: theme.palette.grey[400],
				display: "flex",
				justifyContent: "flex-end",
				webkitJustifyContent: "flex-end"
			},
			customDialog: {},
			body: {
				textAlign: "center",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				flexWrap: "wrap",
				alignItems: "center"
			},
			title: {
				fontSize: 16,
				fontWeight: 400,
				color: theme.palette.common.black,
				marginTop: 10
			},
			subTitle: {
				fontSize: 14,
				fontWeight: 400,
				color: theme.palette.grey[700]
			},
			btnSubmit: {
				color: theme.palette.secondary.main,
				fontSize: 15,
				fontWeight: 400,
				cursor: "pointer",
				padding: 15,
				"&:hover": {
					color: theme.palette.secondary.dark
				}
			},
			borderRight: {
				borderRight: `1px solid ${theme.palette.grey[800]}`
			},
			driver: {
				marginTop: 20,
				borderTop: `1px solid ${theme.palette.grey[200]}`,
				width: "100%"
			},
			btnCancel: {
				background: theme.palette.grey["A100"],
				color: theme.palette.secondary.main,
				border: `1px solid ${theme.palette.secondary.main}`,
				fontSize: 14,
				textTransform: "inherit",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: 36,
				width: "100%",
				borderRadius: 6,
				cursor: "pointer",
				"&:hover": {
					background: `${theme.palette.secondary.dark} !important`
				}
			},
			btnConfirm: {
				background: theme.palette.error.main,
				color: theme.palette.common.white,
				fontSize: 14,
				textTransform: "inherit",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: 36,
				width: "100%",
				borderRadius: 6,
				borderColor: theme.palette.grey["A100"],
				cursor: "pointer",
				"&:hover": {
					background: `${theme.palette.secondary.dark}`
				}
			},
			bodyFooter: {
				marginTop: 10,
				padding: "0px 18px 20px"
			}
		}),
	{
		name: "DialogInformation",
		index: 1
	}
);

export default useStyles;
